import React from 'react'
import { TouchableOpacity, View, useWindowDimensions } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { AppModal } from '../ui/AppModal'
import { PlainPanelSurface } from '../ui/ModalCloseTab'
import { GameOverlayTopContext, floatingGamePanelBounds } from '../../lib/gameOverlayBounds'
import { DESKTOP_BREAKPOINT } from '../../lib/mapDimensions'

/**
 * Shared game-overlay frame: a plain box whose top strip holds the ×, then the body.
 * Phones and tablets pin it under the game's top bar; desktop centres it
 * vertically, since desktop modals cover the top bar too (AppModal).
 */
export function FloatingGamePanel({ visible, onClose, closeLabel, closeTestID, title, children }: {
  visible: boolean; onClose: () => void; closeLabel: string; closeTestID?: string
  /** A heading on the ×'s strip (PlainPanelSurface). */
  title?: React.ReactNode
  children: React.ReactNode
}) {
  const { width, height } = useWindowDimensions()
  const insets = useSafeAreaInsets()
  const desktop = width >= DESKTOP_BREAKPOINT
  const gameTop = React.useContext(GameOverlayTopContext)
  const bounds = floatingGamePanelBounds(height, insets.top, insets.bottom, desktop ? 0 : gameTop)
  return <AppModal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
    <View testID="floating-game-panel-backdrop"
      className={`flex-1 bg-black/40 items-center ${desktop ? 'justify-center' : 'justify-start'}`}
      style={{ paddingTop: bounds.paddingTop, paddingBottom: bounds.paddingBottom }}>
      <TouchableOpacity onPress={onClose} activeOpacity={1} accessibilityLabel={closeLabel} accessibilityRole="button"
        style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }} />
      <View style={{ width: Math.min(560, width * (width > height ? 0.6 : 0.92)), maxHeight: bounds.maxHeight, overflow: 'visible' }}>
        <PlainPanelSurface testID="floating-game-panel" onClose={onClose} closeLabel={closeLabel} closeTestID={closeTestID} title={title}
          style={{ width: '100%', maxHeight: bounds.maxHeight }}>
          {children}
        </PlainPanelSurface>
      </View>
    </View>
  </AppModal>
}
